/* ==========================================================================
   Pussy Liquor lineup filters
   ALL / TEQUILA / VODKA / VARIETY PACK: shows only the cards of the chosen group.
   Cards keep their place in the grid; the screen-reader status announces the count.
   ========================================================================== */
(function () {
  'use strict';

  function setup(bar) {
    if (bar.dataset.plReady) return;
    bar.dataset.plReady = '1';

    var section = bar.closest('.pl-lineup');
    var cards = Array.prototype.slice.call(section.querySelectorAll('.pl-lp'));
    var buttons = Array.prototype.slice.call(bar.querySelectorAll('.pl-filter'));
    var status = section.querySelector('[data-pl-filter-status]');

    function apply(filter) {
      var shown = 0;
      cards.forEach(function (card) {
        var match = filter === 'all' || card.dataset.category === filter;
        var wasHidden = card.hidden;
        card.hidden = !match;
        card.classList.remove('is-showing');
        if (match) {
          shown++;
          if (wasHidden) {
            void card.offsetWidth; /* restart the fade-in */
            card.classList.add('is-showing');
          }
        }
      });
      buttons.forEach(function (btn) {
        var on = btn.dataset.filter === filter;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (status) status.textContent = 'Showing ' + shown + (shown === 1 ? ' product' : ' products');
    }

    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('.pl-filter');
      if (btn) apply(btn.dataset.filter);
    });
  }

  /* ---------- Prev / next arrows (mobile swipe row) ---------- */
  function setupCarousel(root) {
    if (root.dataset.plCarouselReady) return;
    root.dataset.plCarouselReady = '1';

    var grid = root.querySelector('[data-pl-grid]');
    var prev = root.querySelector('[data-pl-lineup-prev]');
    var next = root.querySelector('[data-pl-lineup-next]');
    if (!grid || (!prev && !next)) return;

    function cardWidth() {
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 0;
      return grid.clientWidth + gap;
    }
    function go(n) {
      grid.scrollBy({ left: n * cardWidth(), behavior: 'smooth' });
    }
    function updateArrows() {
      var max = grid.scrollWidth - grid.clientWidth;
      if (prev) prev.disabled = grid.scrollLeft <= 2;
      if (next) next.disabled = grid.scrollLeft >= max - 2;
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    grid.addEventListener('scroll', function () { window.requestAnimationFrame(updateArrows); }, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function init() {
    document.querySelectorAll('[data-pl-filters]').forEach(setup);
    document.querySelectorAll('[data-pl-lineup-carousel]').forEach(setupCarousel);
  }

  init();
  /* Theme editor re-renders sections */
  document.addEventListener('shopify:section:load', init);
})();
